import { NgModule } from '@angular/core';



@NgModule({
  declarations: [ ],
  providers: [ ],
  imports: [ ]
})
export class SecurityModule {
  static isIE: boolean = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
}
